import { render } from "./AboutPublications.vue?vue&type=template&id=38932502&scoped=true"
import script from "./AboutPublications.vue?vue&type=script&lang=js"
export * from "./AboutPublications.vue?vue&type=script&lang=js"

import "./AboutPublications.vue?vue&type=style&index=0&id=38932502&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38932502"]])

export default __exports__